var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAuditorsAndRrRs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2445 19.76C30.5865 22.102 30.5865 25.904 28.2445 28.25C25.9025 30.592 22.1005 30.592 19.7545 28.25C17.4125 25.908 17.4125 22.106 19.7545 19.76C22.1005 17.414 25.9005 17.414 28.2445 19.76Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32L36 38L32 34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38C16.618 38 9.922 34.018 6.892 27.824C6.304 26.622 6 25.318 6 24C6 22.682 6.304 21.378 6.892 20.176C9.922 13.982 16.618 10 24 10C31.382 10 38.078 13.982 41.108 20.176C41.696 21.378 42 22.682 42 24",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAuditorsAndRrRs);
export default __webpack_public_path__ + "static/media/manageAuditorsAndRRRs.367cb08c59ac67c3d43666b7514093cd.svg";
export { ForwardRef as ReactComponent };